import { render, staticRenderFns } from "./CrossChainConfirmation.vue?vue&type=template&id=66fa0b29&scoped=true"
import script from "./CrossChainConfirmation.vue?vue&type=script&lang=js"
export * from "./CrossChainConfirmation.vue?vue&type=script&lang=js"
import style0 from "./CrossChainConfirmation.vue?vue&type=style&index=0&id=66fa0b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa0b29",
  null
  
)

export default component.exports